/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WorkRouteImport } from './routes/work'
import { Route as SitemapDotxmlRouteImport } from './routes/sitemap[.]xml'
import { Route as ServicesRouteImport } from './routes/services'
import { Route as ProcessRouteImport } from './routes/process'
import { Route as IndustriesRouteImport } from './routes/industries'
import { Route as ContactUsRouteImport } from './routes/contact-us'
import { Route as BlogsRouteImport } from './routes/blogs'
import { Route as AboutUsRouteImport } from './routes/about-us'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ServicesWebDevelopmentServicesRouteImport } from './routes/services_.web-development-services'
import { Route as ServicesWebDevelopmentRouteImport } from './routes/services_.web-development'
import { Route as ServicesVisualIdentityRouteImport } from './routes/services_.visual-identity'
import { Route as ServicesVideoProductionRouteImport } from './routes/services_.video-production'
import { Route as ServicesTelevisionRouteImport } from './routes/services_.television'
import { Route as ServicesSocialMediaMarketingServicesRouteImport } from './routes/services_.social-media-marketing-services'
import { Route as ServicesSocialMediaMarketingRouteImport } from './routes/services_.social-media-marketing'
import { Route as ServicesSeoServicesRouteImport } from './routes/services_.seo-services'
import { Route as ServicesSeoRouteImport } from './routes/services_.seo'
import { Route as ServicesResearchConsultingServicesRouteImport } from './routes/services_.research-consulting-services'
import { Route as ServicesResearchConsultingAndMediaAuditServicesRouteImport } from './routes/services_.research-consulting-and-media-audit-services'
import { Route as ServicesResearchConsultingAndCampaignAuditServicesRouteImport } from './routes/services_.research-consulting-and-campaign-audit-services'
import { Route as ServicesResearchConsultingAndBrandAuditServicesRouteImport } from './routes/services_.research-consulting-and-brand-audit-services'
import { Route as ServicesResearchConsultingRouteImport } from './routes/services_.research-consulting'
import { Route as ServicesRadioRouteImport } from './routes/services_.radio'
import { Route as ServicesProgrammaticAdvertisingServicesRouteImport } from './routes/services_.programmatic-advertising-services'
import { Route as ServicesProgrammaticAdvertisingRouteImport } from './routes/services_.programmatic-advertising'
import { Route as ServicesPrintRouteImport } from './routes/services_.print'
import { Route as ServicesPhotographyRouteImport } from './routes/services_.photography'
import { Route as ServicesPerformanceMarketingServicesRouteImport } from './routes/services_.performance-marketing-services'
import { Route as ServicesPerformanceMarketingRouteImport } from './routes/services_.performance-marketing'
import { Route as ServicesOutdoorAdvertisingServicesRouteImport } from './routes/services_.outdoor-advertising-services'
import { Route as ServicesOutdoorRouteImport } from './routes/services_.outdoor'
import { Route as ServicesOttAdvertisingServicesRouteImport } from './routes/services_.ott-advertising-services'
import { Route as ServicesOttAdvertisingRouteImport } from './routes/services_.ott-advertising'
import { Route as ServicesOrmServicesRouteImport } from './routes/services_.orm-services'
import { Route as ServicesOrmRouteImport } from './routes/services_.orm'
import { Route as ServicesMotionGraphicsRouteImport } from './routes/services_.motion-graphics'
import { Route as ServicesLogoDesignRouteImport } from './routes/services_.logo-design'
import { Route as ServicesEmailMarketingServicesRouteImport } from './routes/services_.email-marketing-services'
import { Route as ServicesEmailMarketingRouteImport } from './routes/services_.email-marketing'
import { Route as ServicesDisplayNativeAdsServicesRouteImport } from './routes/services_.display-native-ads-services'
import { Route as ServicesDisplayNativeAdsRouteImport } from './routes/services_.display-native-ads'
import { Route as ServicesDataIntelligenceServicesRouteImport } from './routes/services_.data-intelligence-services'
import { Route as ServicesDataIntelligenceRouteImport } from './routes/services_.data-intelligence'
import { Route as ServicesCroServicesRouteImport } from './routes/services_.cro-services'
import { Route as ServicesCroRouteImport } from './routes/services_.cro'
import { Route as ServicesCorporateOfficeBrandingRouteImport } from './routes/services_.corporate-office-branding'
import { Route as ServicesCopywritingRouteImport } from './routes/services_.copywriting'
import { Route as ServicesCinemaRouteImport } from './routes/services_.cinema'
import { Route as ServicesCampaignDesignRouteImport } from './routes/services_.campaign-design'
import { Route as ServicesBrandingCreativesAndVideoProductionServicesRouteImport } from './routes/services_.branding-creatives-and-video-production-services'
import { Route as ServicesBrandingCreativesAndPhotographyCopywritingServicesRouteImport } from './routes/services_.branding-creatives-and-photography-copywriting-services'
import { Route as ServicesBrandingCreativesAndOfficeBrandingServicesRouteImport } from './routes/services_.branding-creatives-and-office-branding-services'
import { Route as ServicesBrandingCreativesAndMotionAiVideoServicesRouteImport } from './routes/services_.branding-creatives-and-motion-ai-video-services'
import { Route as ServicesBrandingCreativesAndLogoIdentityServicesRouteImport } from './routes/services_.branding-creatives-and-logo-identity-services'
import { Route as ServicesBrandingCreativesAndCampaignDesignServicesRouteImport } from './routes/services_.branding-creatives-and-campaign-design-services'
import { Route as ServicesBrandingCreativesAndBrandStrategyServicesRouteImport } from './routes/services_.branding-creatives-and-brand-strategy-services'
import { Route as ServicesBrandingCreativesRouteImport } from './routes/services_.branding-creatives'
import { Route as ServicesAppAdvertisingServicesRouteImport } from './routes/services_.app-advertising-services'
import { Route as ServicesAppAdvertisingRouteImport } from './routes/services_.app-advertising'
import { Route as ServicesAnalyticsServicesRouteImport } from './routes/services_.analytics-services'
import { Route as ServicesAnalyticsRouteImport } from './routes/services_.analytics'
import { Route as ServicesAiVideoCreationRouteImport } from './routes/services_.ai-video-creation'
import { Route as ServicesAiMarketingServicesRouteImport } from './routes/services_.ai-marketing-services'
import { Route as ServicesAiMarketingRouteImport } from './routes/services_.ai-marketing'
import { Route as ServiceTelevisionAdvertisingServicesRouteImport } from './routes/service_.television-advertising-services'
import { Route as ServiceRadioAdvertisingServicesRouteImport } from './routes/service_.radio-advertising-services'
import { Route as ServicePrintAdvertisementsServicesRouteImport } from './routes/service_.print-advertisements-services'
import { Route as ServiceCinemaAdvertisingServicesRouteImport } from './routes/service_.cinema-advertising-services'
import { Route as DevServicePrintAdvertisementsServicesRouteImport } from './routes/dev_.service_.print-advertisements-services'
import { Route as DevServiceCinemaAdvertisingServicesRouteImport } from './routes/dev_.service_.cinema-advertising-services'

const WorkRoute = WorkRouteImport.update({
  id: '/work',
  path: '/work',
  getParentRoute: () => rootRouteImport,
} as any)
const SitemapDotxmlRoute = SitemapDotxmlRouteImport.update({
  id: '/sitemap.xml',
  path: '/sitemap.xml',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesRoute = ServicesRouteImport.update({
  id: '/services',
  path: '/services',
  getParentRoute: () => rootRouteImport,
} as any)
const ProcessRoute = ProcessRouteImport.update({
  id: '/process',
  path: '/process',
  getParentRoute: () => rootRouteImport,
} as any)
const IndustriesRoute = IndustriesRouteImport.update({
  id: '/industries',
  path: '/industries',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactUsRoute = ContactUsRouteImport.update({
  id: '/contact-us',
  path: '/contact-us',
  getParentRoute: () => rootRouteImport,
} as any)
const BlogsRoute = BlogsRouteImport.update({
  id: '/blogs',
  path: '/blogs',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutUsRoute = AboutUsRouteImport.update({
  id: '/about-us',
  path: '/about-us',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesWebDevelopmentServicesRoute =
  ServicesWebDevelopmentServicesRouteImport.update({
    id: '/services_/web-development-services',
    path: '/services/web-development-services',
    getParentRoute: () => rootRouteImport,
  } as any)
const ServicesWebDevelopmentRoute = ServicesWebDevelopmentRouteImport.update({
  id: '/services_/web-development',
  path: '/services/web-development',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesVisualIdentityRoute = ServicesVisualIdentityRouteImport.update({
  id: '/services_/visual-identity',
  path: '/services/visual-identity',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesVideoProductionRoute = ServicesVideoProductionRouteImport.update({
  id: '/services_/video-production',
  path: '/services/video-production',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesTelevisionRoute = ServicesTelevisionRouteImport.update({
  id: '/services_/television',
  path: '/services/television',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesSocialMediaMarketingServicesRoute =
  ServicesSocialMediaMarketingServicesRouteImport.update({
    id: '/services_/social-media-marketing-services',
    path: '/services/social-media-marketing-services',
    getParentRoute: () => rootRouteImport,
  } as any)
const ServicesSocialMediaMarketingRoute =
  ServicesSocialMediaMarketingRouteImport.update({
    id: '/services_/social-media-marketing',
    path: '/services/social-media-marketing',
    getParentRoute: () => rootRouteImport,
  } as any)
const ServicesSeoServicesRoute = ServicesSeoServicesRouteImport.update({
  id: '/services_/seo-services',
  path: '/services/seo-services',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesSeoRoute = ServicesSeoRouteImport.update({
  id: '/services_/seo',
  path: '/services/seo',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesResearchConsultingServicesRoute =
  ServicesResearchConsultingServicesRouteImport.update({
    id: '/services_/research-consulting-services',
    path: '/services/research-consulting-services',
    getParentRoute: () => rootRouteImport,
  } as any)
const ServicesResearchConsultingAndMediaAuditServicesRoute =
  ServicesResearchConsultingAndMediaAuditServicesRouteImport.update({
    id: '/services_/research-consulting-and-media-audit-services',
    path: '/services/research-consulting-and-media-audit-services',
    getParentRoute: () => rootRouteImport,
  } as any)
const ServicesResearchConsultingAndCampaignAuditServicesRoute =
  ServicesResearchConsultingAndCampaignAuditServicesRouteImport.update({
    id: '/services_/research-consulting-and-campaign-audit-services',
    path: '/services/research-consulting-and-campaign-audit-services',
    getParentRoute: () => rootRouteImport,
  } as any)
const ServicesResearchConsultingAndBrandAuditServicesRoute =
  ServicesResearchConsultingAndBrandAuditServicesRouteImport.update({
    id: '/services_/research-consulting-and-brand-audit-services',
    path: '/services/research-consulting-and-brand-audit-services',
    getParentRoute: () => rootRouteImport,
  } as any)
const ServicesResearchConsultingRoute =
  ServicesResearchConsultingRouteImport.update({
    id: '/services_/research-consulting',
    path: '/services/research-consulting',
    getParentRoute: () => rootRouteImport,
  } as any)
const ServicesRadioRoute = ServicesRadioRouteImport.update({
  id: '/services_/radio',
  path: '/services/radio',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesProgrammaticAdvertisingServicesRoute =
  ServicesProgrammaticAdvertisingServicesRouteImport.update({
    id: '/services_/programmatic-advertising-services',
    path: '/services/programmatic-advertising-services',
    getParentRoute: () => rootRouteImport,
  } as any)
const ServicesProgrammaticAdvertisingRoute =
  ServicesProgrammaticAdvertisingRouteImport.update({
    id: '/services_/programmatic-advertising',
    path: '/services/programmatic-advertising',
    getParentRoute: () => rootRouteImport,
  } as any)
const ServicesPrintRoute = ServicesPrintRouteImport.update({
  id: '/services_/print',
  path: '/services/print',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesPhotographyRoute = ServicesPhotographyRouteImport.update({
  id: '/services_/photography',
  path: '/services/photography',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesPerformanceMarketingServicesRoute =
  ServicesPerformanceMarketingServicesRouteImport.update({
    id: '/services_/performance-marketing-services',
    path: '/services/performance-marketing-services',
    getParentRoute: () => rootRouteImport,
  } as any)
const ServicesPerformanceMarketingRoute =
  ServicesPerformanceMarketingRouteImport.update({
    id: '/services_/performance-marketing',
    path: '/services/performance-marketing',
    getParentRoute: () => rootRouteImport,
  } as any)
const ServicesOutdoorAdvertisingServicesRoute =
  ServicesOutdoorAdvertisingServicesRouteImport.update({
    id: '/services_/outdoor-advertising-services',
    path: '/services/outdoor-advertising-services',
    getParentRoute: () => rootRouteImport,
  } as any)
const ServicesOutdoorRoute = ServicesOutdoorRouteImport.update({
  id: '/services_/outdoor',
  path: '/services/outdoor',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesOttAdvertisingServicesRoute =
  ServicesOttAdvertisingServicesRouteImport.update({
    id: '/services_/ott-advertising-services',
    path: '/services/ott-advertising-services',
    getParentRoute: () => rootRouteImport,
  } as any)
const ServicesOttAdvertisingRoute = ServicesOttAdvertisingRouteImport.update({
  id: '/services_/ott-advertising',
  path: '/services/ott-advertising',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesOrmServicesRoute = ServicesOrmServicesRouteImport.update({
  id: '/services_/orm-services',
  path: '/services/orm-services',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesOrmRoute = ServicesOrmRouteImport.update({
  id: '/services_/orm',
  path: '/services/orm',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesMotionGraphicsRoute = ServicesMotionGraphicsRouteImport.update({
  id: '/services_/motion-graphics',
  path: '/services/motion-graphics',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesLogoDesignRoute = ServicesLogoDesignRouteImport.update({
  id: '/services_/logo-design',
  path: '/services/logo-design',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesEmailMarketingServicesRoute =
  ServicesEmailMarketingServicesRouteImport.update({
    id: '/services_/email-marketing-services',
    path: '/services/email-marketing-services',
    getParentRoute: () => rootRouteImport,
  } as any)
const ServicesEmailMarketingRoute = ServicesEmailMarketingRouteImport.update({
  id: '/services_/email-marketing',
  path: '/services/email-marketing',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesDisplayNativeAdsServicesRoute =
  ServicesDisplayNativeAdsServicesRouteImport.update({
    id: '/services_/display-native-ads-services',
    path: '/services/display-native-ads-services',
    getParentRoute: () => rootRouteImport,
  } as any)
const ServicesDisplayNativeAdsRoute =
  ServicesDisplayNativeAdsRouteImport.update({
    id: '/services_/display-native-ads',
    path: '/services/display-native-ads',
    getParentRoute: () => rootRouteImport,
  } as any)
const ServicesDataIntelligenceServicesRoute =
  ServicesDataIntelligenceServicesRouteImport.update({
    id: '/services_/data-intelligence-services',
    path: '/services/data-intelligence-services',
    getParentRoute: () => rootRouteImport,
  } as any)
const ServicesDataIntelligenceRoute =
  ServicesDataIntelligenceRouteImport.update({
    id: '/services_/data-intelligence',
    path: '/services/data-intelligence',
    getParentRoute: () => rootRouteImport,
  } as any)
const ServicesCroServicesRoute = ServicesCroServicesRouteImport.update({
  id: '/services_/cro-services',
  path: '/services/cro-services',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesCroRoute = ServicesCroRouteImport.update({
  id: '/services_/cro',
  path: '/services/cro',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesCorporateOfficeBrandingRoute =
  ServicesCorporateOfficeBrandingRouteImport.update({
    id: '/services_/corporate-office-branding',
    path: '/services/corporate-office-branding',
    getParentRoute: () => rootRouteImport,
  } as any)
const ServicesCopywritingRoute = ServicesCopywritingRouteImport.update({
  id: '/services_/copywriting',
  path: '/services/copywriting',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesCinemaRoute = ServicesCinemaRouteImport.update({
  id: '/services_/cinema',
  path: '/services/cinema',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesCampaignDesignRoute = ServicesCampaignDesignRouteImport.update({
  id: '/services_/campaign-design',
  path: '/services/campaign-design',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesBrandingCreativesAndVideoProductionServicesRoute =
  ServicesBrandingCreativesAndVideoProductionServicesRouteImport.update({
    id: '/services_/branding-creatives-and-video-production-services',
    path: '/services/branding-creatives-and-video-production-services',
    getParentRoute: () => rootRouteImport,
  } as any)
const ServicesBrandingCreativesAndPhotographyCopywritingServicesRoute =
  ServicesBrandingCreativesAndPhotographyCopywritingServicesRouteImport.update({
    id: '/services_/branding-creatives-and-photography-copywriting-services',
    path: '/services/branding-creatives-and-photography-copywriting-services',
    getParentRoute: () => rootRouteImport,
  } as any)
const ServicesBrandingCreativesAndOfficeBrandingServicesRoute =
  ServicesBrandingCreativesAndOfficeBrandingServicesRouteImport.update({
    id: '/services_/branding-creatives-and-office-branding-services',
    path: '/services/branding-creatives-and-office-branding-services',
    getParentRoute: () => rootRouteImport,
  } as any)
const ServicesBrandingCreativesAndMotionAiVideoServicesRoute =
  ServicesBrandingCreativesAndMotionAiVideoServicesRouteImport.update({
    id: '/services_/branding-creatives-and-motion-ai-video-services',
    path: '/services/branding-creatives-and-motion-ai-video-services',
    getParentRoute: () => rootRouteImport,
  } as any)
const ServicesBrandingCreativesAndLogoIdentityServicesRoute =
  ServicesBrandingCreativesAndLogoIdentityServicesRouteImport.update({
    id: '/services_/branding-creatives-and-logo-identity-services',
    path: '/services/branding-creatives-and-logo-identity-services',
    getParentRoute: () => rootRouteImport,
  } as any)
const ServicesBrandingCreativesAndCampaignDesignServicesRoute =
  ServicesBrandingCreativesAndCampaignDesignServicesRouteImport.update({
    id: '/services_/branding-creatives-and-campaign-design-services',
    path: '/services/branding-creatives-and-campaign-design-services',
    getParentRoute: () => rootRouteImport,
  } as any)
const ServicesBrandingCreativesAndBrandStrategyServicesRoute =
  ServicesBrandingCreativesAndBrandStrategyServicesRouteImport.update({
    id: '/services_/branding-creatives-and-brand-strategy-services',
    path: '/services/branding-creatives-and-brand-strategy-services',
    getParentRoute: () => rootRouteImport,
  } as any)
const ServicesBrandingCreativesRoute =
  ServicesBrandingCreativesRouteImport.update({
    id: '/services_/branding-creatives',
    path: '/services/branding-creatives',
    getParentRoute: () => rootRouteImport,
  } as any)
const ServicesAppAdvertisingServicesRoute =
  ServicesAppAdvertisingServicesRouteImport.update({
    id: '/services_/app-advertising-services',
    path: '/services/app-advertising-services',
    getParentRoute: () => rootRouteImport,
  } as any)
const ServicesAppAdvertisingRoute = ServicesAppAdvertisingRouteImport.update({
  id: '/services_/app-advertising',
  path: '/services/app-advertising',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesAnalyticsServicesRoute =
  ServicesAnalyticsServicesRouteImport.update({
    id: '/services_/analytics-services',
    path: '/services/analytics-services',
    getParentRoute: () => rootRouteImport,
  } as any)
const ServicesAnalyticsRoute = ServicesAnalyticsRouteImport.update({
  id: '/services_/analytics',
  path: '/services/analytics',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesAiVideoCreationRoute = ServicesAiVideoCreationRouteImport.update({
  id: '/services_/ai-video-creation',
  path: '/services/ai-video-creation',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesAiMarketingServicesRoute =
  ServicesAiMarketingServicesRouteImport.update({
    id: '/services_/ai-marketing-services',
    path: '/services/ai-marketing-services',
    getParentRoute: () => rootRouteImport,
  } as any)
const ServicesAiMarketingRoute = ServicesAiMarketingRouteImport.update({
  id: '/services_/ai-marketing',
  path: '/services/ai-marketing',
  getParentRoute: () => rootRouteImport,
} as any)
const ServiceTelevisionAdvertisingServicesRoute =
  ServiceTelevisionAdvertisingServicesRouteImport.update({
    id: '/service_/television-advertising-services',
    path: '/service/television-advertising-services',
    getParentRoute: () => rootRouteImport,
  } as any)
const ServiceRadioAdvertisingServicesRoute =
  ServiceRadioAdvertisingServicesRouteImport.update({
    id: '/service_/radio-advertising-services',
    path: '/service/radio-advertising-services',
    getParentRoute: () => rootRouteImport,
  } as any)
const ServicePrintAdvertisementsServicesRoute =
  ServicePrintAdvertisementsServicesRouteImport.update({
    id: '/service_/print-advertisements-services',
    path: '/service/print-advertisements-services',
    getParentRoute: () => rootRouteImport,
  } as any)
const ServiceCinemaAdvertisingServicesRoute =
  ServiceCinemaAdvertisingServicesRouteImport.update({
    id: '/service_/cinema-advertising-services',
    path: '/service/cinema-advertising-services',
    getParentRoute: () => rootRouteImport,
  } as any)
const DevServicePrintAdvertisementsServicesRoute =
  DevServicePrintAdvertisementsServicesRouteImport.update({
    id: '/dev_/service_/print-advertisements-services',
    path: '/dev/service/print-advertisements-services',
    getParentRoute: () => rootRouteImport,
  } as any)
const DevServiceCinemaAdvertisingServicesRoute =
  DevServiceCinemaAdvertisingServicesRouteImport.update({
    id: '/dev_/service_/cinema-advertising-services',
    path: '/dev/service/cinema-advertising-services',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/about-us': typeof AboutUsRoute
  '/blogs': typeof BlogsRoute
  '/contact-us': typeof ContactUsRoute
  '/industries': typeof IndustriesRoute
  '/process': typeof ProcessRoute
  '/services': typeof ServicesRoute
  '/sitemap.xml': typeof SitemapDotxmlRoute
  '/work': typeof WorkRoute
  '/service/cinema-advertising-services': typeof ServiceCinemaAdvertisingServicesRoute
  '/service/print-advertisements-services': typeof ServicePrintAdvertisementsServicesRoute
  '/service/radio-advertising-services': typeof ServiceRadioAdvertisingServicesRoute
  '/service/television-advertising-services': typeof ServiceTelevisionAdvertisingServicesRoute
  '/services/ai-marketing': typeof ServicesAiMarketingRoute
  '/services/ai-marketing-services': typeof ServicesAiMarketingServicesRoute
  '/services/ai-video-creation': typeof ServicesAiVideoCreationRoute
  '/services/analytics': typeof ServicesAnalyticsRoute
  '/services/analytics-services': typeof ServicesAnalyticsServicesRoute
  '/services/app-advertising': typeof ServicesAppAdvertisingRoute
  '/services/app-advertising-services': typeof ServicesAppAdvertisingServicesRoute
  '/services/branding-creatives': typeof ServicesBrandingCreativesRoute
  '/services/branding-creatives-and-brand-strategy-services': typeof ServicesBrandingCreativesAndBrandStrategyServicesRoute
  '/services/branding-creatives-and-campaign-design-services': typeof ServicesBrandingCreativesAndCampaignDesignServicesRoute
  '/services/branding-creatives-and-logo-identity-services': typeof ServicesBrandingCreativesAndLogoIdentityServicesRoute
  '/services/branding-creatives-and-motion-ai-video-services': typeof ServicesBrandingCreativesAndMotionAiVideoServicesRoute
  '/services/branding-creatives-and-office-branding-services': typeof ServicesBrandingCreativesAndOfficeBrandingServicesRoute
  '/services/branding-creatives-and-photography-copywriting-services': typeof ServicesBrandingCreativesAndPhotographyCopywritingServicesRoute
  '/services/branding-creatives-and-video-production-services': typeof ServicesBrandingCreativesAndVideoProductionServicesRoute
  '/services/campaign-design': typeof ServicesCampaignDesignRoute
  '/services/cinema': typeof ServicesCinemaRoute
  '/services/copywriting': typeof ServicesCopywritingRoute
  '/services/corporate-office-branding': typeof ServicesCorporateOfficeBrandingRoute
  '/services/cro': typeof ServicesCroRoute
  '/services/cro-services': typeof ServicesCroServicesRoute
  '/services/data-intelligence': typeof ServicesDataIntelligenceRoute
  '/services/data-intelligence-services': typeof ServicesDataIntelligenceServicesRoute
  '/services/display-native-ads': typeof ServicesDisplayNativeAdsRoute
  '/services/display-native-ads-services': typeof ServicesDisplayNativeAdsServicesRoute
  '/services/email-marketing': typeof ServicesEmailMarketingRoute
  '/services/email-marketing-services': typeof ServicesEmailMarketingServicesRoute
  '/services/logo-design': typeof ServicesLogoDesignRoute
  '/services/motion-graphics': typeof ServicesMotionGraphicsRoute
  '/services/orm': typeof ServicesOrmRoute
  '/services/orm-services': typeof ServicesOrmServicesRoute
  '/services/ott-advertising': typeof ServicesOttAdvertisingRoute
  '/services/ott-advertising-services': typeof ServicesOttAdvertisingServicesRoute
  '/services/outdoor': typeof ServicesOutdoorRoute
  '/services/outdoor-advertising-services': typeof ServicesOutdoorAdvertisingServicesRoute
  '/services/performance-marketing': typeof ServicesPerformanceMarketingRoute
  '/services/performance-marketing-services': typeof ServicesPerformanceMarketingServicesRoute
  '/services/photography': typeof ServicesPhotographyRoute
  '/services/print': typeof ServicesPrintRoute
  '/services/programmatic-advertising': typeof ServicesProgrammaticAdvertisingRoute
  '/services/programmatic-advertising-services': typeof ServicesProgrammaticAdvertisingServicesRoute
  '/services/radio': typeof ServicesRadioRoute
  '/services/research-consulting': typeof ServicesResearchConsultingRoute
  '/services/research-consulting-and-brand-audit-services': typeof ServicesResearchConsultingAndBrandAuditServicesRoute
  '/services/research-consulting-and-campaign-audit-services': typeof ServicesResearchConsultingAndCampaignAuditServicesRoute
  '/services/research-consulting-and-media-audit-services': typeof ServicesResearchConsultingAndMediaAuditServicesRoute
  '/services/research-consulting-services': typeof ServicesResearchConsultingServicesRoute
  '/services/seo': typeof ServicesSeoRoute
  '/services/seo-services': typeof ServicesSeoServicesRoute
  '/services/social-media-marketing': typeof ServicesSocialMediaMarketingRoute
  '/services/social-media-marketing-services': typeof ServicesSocialMediaMarketingServicesRoute
  '/services/television': typeof ServicesTelevisionRoute
  '/services/video-production': typeof ServicesVideoProductionRoute
  '/services/visual-identity': typeof ServicesVisualIdentityRoute
  '/services/web-development': typeof ServicesWebDevelopmentRoute
  '/services/web-development-services': typeof ServicesWebDevelopmentServicesRoute
  '/dev/service/cinema-advertising-services': typeof DevServiceCinemaAdvertisingServicesRoute
  '/dev/service/print-advertisements-services': typeof DevServicePrintAdvertisementsServicesRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/about-us': typeof AboutUsRoute
  '/blogs': typeof BlogsRoute
  '/contact-us': typeof ContactUsRoute
  '/industries': typeof IndustriesRoute
  '/process': typeof ProcessRoute
  '/services': typeof ServicesRoute
  '/sitemap.xml': typeof SitemapDotxmlRoute
  '/work': typeof WorkRoute
  '/service/cinema-advertising-services': typeof ServiceCinemaAdvertisingServicesRoute
  '/service/print-advertisements-services': typeof ServicePrintAdvertisementsServicesRoute
  '/service/radio-advertising-services': typeof ServiceRadioAdvertisingServicesRoute
  '/service/television-advertising-services': typeof ServiceTelevisionAdvertisingServicesRoute
  '/services/ai-marketing': typeof ServicesAiMarketingRoute
  '/services/ai-marketing-services': typeof ServicesAiMarketingServicesRoute
  '/services/ai-video-creation': typeof ServicesAiVideoCreationRoute
  '/services/analytics': typeof ServicesAnalyticsRoute
  '/services/analytics-services': typeof ServicesAnalyticsServicesRoute
  '/services/app-advertising': typeof ServicesAppAdvertisingRoute
  '/services/app-advertising-services': typeof ServicesAppAdvertisingServicesRoute
  '/services/branding-creatives': typeof ServicesBrandingCreativesRoute
  '/services/branding-creatives-and-brand-strategy-services': typeof ServicesBrandingCreativesAndBrandStrategyServicesRoute
  '/services/branding-creatives-and-campaign-design-services': typeof ServicesBrandingCreativesAndCampaignDesignServicesRoute
  '/services/branding-creatives-and-logo-identity-services': typeof ServicesBrandingCreativesAndLogoIdentityServicesRoute
  '/services/branding-creatives-and-motion-ai-video-services': typeof ServicesBrandingCreativesAndMotionAiVideoServicesRoute
  '/services/branding-creatives-and-office-branding-services': typeof ServicesBrandingCreativesAndOfficeBrandingServicesRoute
  '/services/branding-creatives-and-photography-copywriting-services': typeof ServicesBrandingCreativesAndPhotographyCopywritingServicesRoute
  '/services/branding-creatives-and-video-production-services': typeof ServicesBrandingCreativesAndVideoProductionServicesRoute
  '/services/campaign-design': typeof ServicesCampaignDesignRoute
  '/services/cinema': typeof ServicesCinemaRoute
  '/services/copywriting': typeof ServicesCopywritingRoute
  '/services/corporate-office-branding': typeof ServicesCorporateOfficeBrandingRoute
  '/services/cro': typeof ServicesCroRoute
  '/services/cro-services': typeof ServicesCroServicesRoute
  '/services/data-intelligence': typeof ServicesDataIntelligenceRoute
  '/services/data-intelligence-services': typeof ServicesDataIntelligenceServicesRoute
  '/services/display-native-ads': typeof ServicesDisplayNativeAdsRoute
  '/services/display-native-ads-services': typeof ServicesDisplayNativeAdsServicesRoute
  '/services/email-marketing': typeof ServicesEmailMarketingRoute
  '/services/email-marketing-services': typeof ServicesEmailMarketingServicesRoute
  '/services/logo-design': typeof ServicesLogoDesignRoute
  '/services/motion-graphics': typeof ServicesMotionGraphicsRoute
  '/services/orm': typeof ServicesOrmRoute
  '/services/orm-services': typeof ServicesOrmServicesRoute
  '/services/ott-advertising': typeof ServicesOttAdvertisingRoute
  '/services/ott-advertising-services': typeof ServicesOttAdvertisingServicesRoute
  '/services/outdoor': typeof ServicesOutdoorRoute
  '/services/outdoor-advertising-services': typeof ServicesOutdoorAdvertisingServicesRoute
  '/services/performance-marketing': typeof ServicesPerformanceMarketingRoute
  '/services/performance-marketing-services': typeof ServicesPerformanceMarketingServicesRoute
  '/services/photography': typeof ServicesPhotographyRoute
  '/services/print': typeof ServicesPrintRoute
  '/services/programmatic-advertising': typeof ServicesProgrammaticAdvertisingRoute
  '/services/programmatic-advertising-services': typeof ServicesProgrammaticAdvertisingServicesRoute
  '/services/radio': typeof ServicesRadioRoute
  '/services/research-consulting': typeof ServicesResearchConsultingRoute
  '/services/research-consulting-and-brand-audit-services': typeof ServicesResearchConsultingAndBrandAuditServicesRoute
  '/services/research-consulting-and-campaign-audit-services': typeof ServicesResearchConsultingAndCampaignAuditServicesRoute
  '/services/research-consulting-and-media-audit-services': typeof ServicesResearchConsultingAndMediaAuditServicesRoute
  '/services/research-consulting-services': typeof ServicesResearchConsultingServicesRoute
  '/services/seo': typeof ServicesSeoRoute
  '/services/seo-services': typeof ServicesSeoServicesRoute
  '/services/social-media-marketing': typeof ServicesSocialMediaMarketingRoute
  '/services/social-media-marketing-services': typeof ServicesSocialMediaMarketingServicesRoute
  '/services/television': typeof ServicesTelevisionRoute
  '/services/video-production': typeof ServicesVideoProductionRoute
  '/services/visual-identity': typeof ServicesVisualIdentityRoute
  '/services/web-development': typeof ServicesWebDevelopmentRoute
  '/services/web-development-services': typeof ServicesWebDevelopmentServicesRoute
  '/dev/service/cinema-advertising-services': typeof DevServiceCinemaAdvertisingServicesRoute
  '/dev/service/print-advertisements-services': typeof DevServicePrintAdvertisementsServicesRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/about-us': typeof AboutUsRoute
  '/blogs': typeof BlogsRoute
  '/contact-us': typeof ContactUsRoute
  '/industries': typeof IndustriesRoute
  '/process': typeof ProcessRoute
  '/services': typeof ServicesRoute
  '/sitemap.xml': typeof SitemapDotxmlRoute
  '/work': typeof WorkRoute
  '/service_/cinema-advertising-services': typeof ServiceCinemaAdvertisingServicesRoute
  '/service_/print-advertisements-services': typeof ServicePrintAdvertisementsServicesRoute
  '/service_/radio-advertising-services': typeof ServiceRadioAdvertisingServicesRoute
  '/service_/television-advertising-services': typeof ServiceTelevisionAdvertisingServicesRoute
  '/services_/ai-marketing': typeof ServicesAiMarketingRoute
  '/services_/ai-marketing-services': typeof ServicesAiMarketingServicesRoute
  '/services_/ai-video-creation': typeof ServicesAiVideoCreationRoute
  '/services_/analytics': typeof ServicesAnalyticsRoute
  '/services_/analytics-services': typeof ServicesAnalyticsServicesRoute
  '/services_/app-advertising': typeof ServicesAppAdvertisingRoute
  '/services_/app-advertising-services': typeof ServicesAppAdvertisingServicesRoute
  '/services_/branding-creatives': typeof ServicesBrandingCreativesRoute
  '/services_/branding-creatives-and-brand-strategy-services': typeof ServicesBrandingCreativesAndBrandStrategyServicesRoute
  '/services_/branding-creatives-and-campaign-design-services': typeof ServicesBrandingCreativesAndCampaignDesignServicesRoute
  '/services_/branding-creatives-and-logo-identity-services': typeof ServicesBrandingCreativesAndLogoIdentityServicesRoute
  '/services_/branding-creatives-and-motion-ai-video-services': typeof ServicesBrandingCreativesAndMotionAiVideoServicesRoute
  '/services_/branding-creatives-and-office-branding-services': typeof ServicesBrandingCreativesAndOfficeBrandingServicesRoute
  '/services_/branding-creatives-and-photography-copywriting-services': typeof ServicesBrandingCreativesAndPhotographyCopywritingServicesRoute
  '/services_/branding-creatives-and-video-production-services': typeof ServicesBrandingCreativesAndVideoProductionServicesRoute
  '/services_/campaign-design': typeof ServicesCampaignDesignRoute
  '/services_/cinema': typeof ServicesCinemaRoute
  '/services_/copywriting': typeof ServicesCopywritingRoute
  '/services_/corporate-office-branding': typeof ServicesCorporateOfficeBrandingRoute
  '/services_/cro': typeof ServicesCroRoute
  '/services_/cro-services': typeof ServicesCroServicesRoute
  '/services_/data-intelligence': typeof ServicesDataIntelligenceRoute
  '/services_/data-intelligence-services': typeof ServicesDataIntelligenceServicesRoute
  '/services_/display-native-ads': typeof ServicesDisplayNativeAdsRoute
  '/services_/display-native-ads-services': typeof ServicesDisplayNativeAdsServicesRoute
  '/services_/email-marketing': typeof ServicesEmailMarketingRoute
  '/services_/email-marketing-services': typeof ServicesEmailMarketingServicesRoute
  '/services_/logo-design': typeof ServicesLogoDesignRoute
  '/services_/motion-graphics': typeof ServicesMotionGraphicsRoute
  '/services_/orm': typeof ServicesOrmRoute
  '/services_/orm-services': typeof ServicesOrmServicesRoute
  '/services_/ott-advertising': typeof ServicesOttAdvertisingRoute
  '/services_/ott-advertising-services': typeof ServicesOttAdvertisingServicesRoute
  '/services_/outdoor': typeof ServicesOutdoorRoute
  '/services_/outdoor-advertising-services': typeof ServicesOutdoorAdvertisingServicesRoute
  '/services_/performance-marketing': typeof ServicesPerformanceMarketingRoute
  '/services_/performance-marketing-services': typeof ServicesPerformanceMarketingServicesRoute
  '/services_/photography': typeof ServicesPhotographyRoute
  '/services_/print': typeof ServicesPrintRoute
  '/services_/programmatic-advertising': typeof ServicesProgrammaticAdvertisingRoute
  '/services_/programmatic-advertising-services': typeof ServicesProgrammaticAdvertisingServicesRoute
  '/services_/radio': typeof ServicesRadioRoute
  '/services_/research-consulting': typeof ServicesResearchConsultingRoute
  '/services_/research-consulting-and-brand-audit-services': typeof ServicesResearchConsultingAndBrandAuditServicesRoute
  '/services_/research-consulting-and-campaign-audit-services': typeof ServicesResearchConsultingAndCampaignAuditServicesRoute
  '/services_/research-consulting-and-media-audit-services': typeof ServicesResearchConsultingAndMediaAuditServicesRoute
  '/services_/research-consulting-services': typeof ServicesResearchConsultingServicesRoute
  '/services_/seo': typeof ServicesSeoRoute
  '/services_/seo-services': typeof ServicesSeoServicesRoute
  '/services_/social-media-marketing': typeof ServicesSocialMediaMarketingRoute
  '/services_/social-media-marketing-services': typeof ServicesSocialMediaMarketingServicesRoute
  '/services_/television': typeof ServicesTelevisionRoute
  '/services_/video-production': typeof ServicesVideoProductionRoute
  '/services_/visual-identity': typeof ServicesVisualIdentityRoute
  '/services_/web-development': typeof ServicesWebDevelopmentRoute
  '/services_/web-development-services': typeof ServicesWebDevelopmentServicesRoute
  '/dev_/service_/cinema-advertising-services': typeof DevServiceCinemaAdvertisingServicesRoute
  '/dev_/service_/print-advertisements-services': typeof DevServicePrintAdvertisementsServicesRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/about-us'
    | '/blogs'
    | '/contact-us'
    | '/industries'
    | '/process'
    | '/services'
    | '/sitemap.xml'
    | '/work'
    | '/service/cinema-advertising-services'
    | '/service/print-advertisements-services'
    | '/service/radio-advertising-services'
    | '/service/television-advertising-services'
    | '/services/ai-marketing'
    | '/services/ai-marketing-services'
    | '/services/ai-video-creation'
    | '/services/analytics'
    | '/services/analytics-services'
    | '/services/app-advertising'
    | '/services/app-advertising-services'
    | '/services/branding-creatives'
    | '/services/branding-creatives-and-brand-strategy-services'
    | '/services/branding-creatives-and-campaign-design-services'
    | '/services/branding-creatives-and-logo-identity-services'
    | '/services/branding-creatives-and-motion-ai-video-services'
    | '/services/branding-creatives-and-office-branding-services'
    | '/services/branding-creatives-and-photography-copywriting-services'
    | '/services/branding-creatives-and-video-production-services'
    | '/services/campaign-design'
    | '/services/cinema'
    | '/services/copywriting'
    | '/services/corporate-office-branding'
    | '/services/cro'
    | '/services/cro-services'
    | '/services/data-intelligence'
    | '/services/data-intelligence-services'
    | '/services/display-native-ads'
    | '/services/display-native-ads-services'
    | '/services/email-marketing'
    | '/services/email-marketing-services'
    | '/services/logo-design'
    | '/services/motion-graphics'
    | '/services/orm'
    | '/services/orm-services'
    | '/services/ott-advertising'
    | '/services/ott-advertising-services'
    | '/services/outdoor'
    | '/services/outdoor-advertising-services'
    | '/services/performance-marketing'
    | '/services/performance-marketing-services'
    | '/services/photography'
    | '/services/print'
    | '/services/programmatic-advertising'
    | '/services/programmatic-advertising-services'
    | '/services/radio'
    | '/services/research-consulting'
    | '/services/research-consulting-and-brand-audit-services'
    | '/services/research-consulting-and-campaign-audit-services'
    | '/services/research-consulting-and-media-audit-services'
    | '/services/research-consulting-services'
    | '/services/seo'
    | '/services/seo-services'
    | '/services/social-media-marketing'
    | '/services/social-media-marketing-services'
    | '/services/television'
    | '/services/video-production'
    | '/services/visual-identity'
    | '/services/web-development'
    | '/services/web-development-services'
    | '/dev/service/cinema-advertising-services'
    | '/dev/service/print-advertisements-services'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/about-us'
    | '/blogs'
    | '/contact-us'
    | '/industries'
    | '/process'
    | '/services'
    | '/sitemap.xml'
    | '/work'
    | '/service/cinema-advertising-services'
    | '/service/print-advertisements-services'
    | '/service/radio-advertising-services'
    | '/service/television-advertising-services'
    | '/services/ai-marketing'
    | '/services/ai-marketing-services'
    | '/services/ai-video-creation'
    | '/services/analytics'
    | '/services/analytics-services'
    | '/services/app-advertising'
    | '/services/app-advertising-services'
    | '/services/branding-creatives'
    | '/services/branding-creatives-and-brand-strategy-services'
    | '/services/branding-creatives-and-campaign-design-services'
    | '/services/branding-creatives-and-logo-identity-services'
    | '/services/branding-creatives-and-motion-ai-video-services'
    | '/services/branding-creatives-and-office-branding-services'
    | '/services/branding-creatives-and-photography-copywriting-services'
    | '/services/branding-creatives-and-video-production-services'
    | '/services/campaign-design'
    | '/services/cinema'
    | '/services/copywriting'
    | '/services/corporate-office-branding'
    | '/services/cro'
    | '/services/cro-services'
    | '/services/data-intelligence'
    | '/services/data-intelligence-services'
    | '/services/display-native-ads'
    | '/services/display-native-ads-services'
    | '/services/email-marketing'
    | '/services/email-marketing-services'
    | '/services/logo-design'
    | '/services/motion-graphics'
    | '/services/orm'
    | '/services/orm-services'
    | '/services/ott-advertising'
    | '/services/ott-advertising-services'
    | '/services/outdoor'
    | '/services/outdoor-advertising-services'
    | '/services/performance-marketing'
    | '/services/performance-marketing-services'
    | '/services/photography'
    | '/services/print'
    | '/services/programmatic-advertising'
    | '/services/programmatic-advertising-services'
    | '/services/radio'
    | '/services/research-consulting'
    | '/services/research-consulting-and-brand-audit-services'
    | '/services/research-consulting-and-campaign-audit-services'
    | '/services/research-consulting-and-media-audit-services'
    | '/services/research-consulting-services'
    | '/services/seo'
    | '/services/seo-services'
    | '/services/social-media-marketing'
    | '/services/social-media-marketing-services'
    | '/services/television'
    | '/services/video-production'
    | '/services/visual-identity'
    | '/services/web-development'
    | '/services/web-development-services'
    | '/dev/service/cinema-advertising-services'
    | '/dev/service/print-advertisements-services'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/about-us'
    | '/blogs'
    | '/contact-us'
    | '/industries'
    | '/process'
    | '/services'
    | '/sitemap.xml'
    | '/work'
    | '/service_/cinema-advertising-services'
    | '/service_/print-advertisements-services'
    | '/service_/radio-advertising-services'
    | '/service_/television-advertising-services'
    | '/services_/ai-marketing'
    | '/services_/ai-marketing-services'
    | '/services_/ai-video-creation'
    | '/services_/analytics'
    | '/services_/analytics-services'
    | '/services_/app-advertising'
    | '/services_/app-advertising-services'
    | '/services_/branding-creatives'
    | '/services_/branding-creatives-and-brand-strategy-services'
    | '/services_/branding-creatives-and-campaign-design-services'
    | '/services_/branding-creatives-and-logo-identity-services'
    | '/services_/branding-creatives-and-motion-ai-video-services'
    | '/services_/branding-creatives-and-office-branding-services'
    | '/services_/branding-creatives-and-photography-copywriting-services'
    | '/services_/branding-creatives-and-video-production-services'
    | '/services_/campaign-design'
    | '/services_/cinema'
    | '/services_/copywriting'
    | '/services_/corporate-office-branding'
    | '/services_/cro'
    | '/services_/cro-services'
    | '/services_/data-intelligence'
    | '/services_/data-intelligence-services'
    | '/services_/display-native-ads'
    | '/services_/display-native-ads-services'
    | '/services_/email-marketing'
    | '/services_/email-marketing-services'
    | '/services_/logo-design'
    | '/services_/motion-graphics'
    | '/services_/orm'
    | '/services_/orm-services'
    | '/services_/ott-advertising'
    | '/services_/ott-advertising-services'
    | '/services_/outdoor'
    | '/services_/outdoor-advertising-services'
    | '/services_/performance-marketing'
    | '/services_/performance-marketing-services'
    | '/services_/photography'
    | '/services_/print'
    | '/services_/programmatic-advertising'
    | '/services_/programmatic-advertising-services'
    | '/services_/radio'
    | '/services_/research-consulting'
    | '/services_/research-consulting-and-brand-audit-services'
    | '/services_/research-consulting-and-campaign-audit-services'
    | '/services_/research-consulting-and-media-audit-services'
    | '/services_/research-consulting-services'
    | '/services_/seo'
    | '/services_/seo-services'
    | '/services_/social-media-marketing'
    | '/services_/social-media-marketing-services'
    | '/services_/television'
    | '/services_/video-production'
    | '/services_/visual-identity'
    | '/services_/web-development'
    | '/services_/web-development-services'
    | '/dev_/service_/cinema-advertising-services'
    | '/dev_/service_/print-advertisements-services'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  AboutUsRoute: typeof AboutUsRoute
  BlogsRoute: typeof BlogsRoute
  ContactUsRoute: typeof ContactUsRoute
  IndustriesRoute: typeof IndustriesRoute
  ProcessRoute: typeof ProcessRoute
  ServicesRoute: typeof ServicesRoute
  SitemapDotxmlRoute: typeof SitemapDotxmlRoute
  WorkRoute: typeof WorkRoute
  ServiceCinemaAdvertisingServicesRoute: typeof ServiceCinemaAdvertisingServicesRoute
  ServicePrintAdvertisementsServicesRoute: typeof ServicePrintAdvertisementsServicesRoute
  ServiceRadioAdvertisingServicesRoute: typeof ServiceRadioAdvertisingServicesRoute
  ServiceTelevisionAdvertisingServicesRoute: typeof ServiceTelevisionAdvertisingServicesRoute
  ServicesAiMarketingRoute: typeof ServicesAiMarketingRoute
  ServicesAiMarketingServicesRoute: typeof ServicesAiMarketingServicesRoute
  ServicesAiVideoCreationRoute: typeof ServicesAiVideoCreationRoute
  ServicesAnalyticsRoute: typeof ServicesAnalyticsRoute
  ServicesAnalyticsServicesRoute: typeof ServicesAnalyticsServicesRoute
  ServicesAppAdvertisingRoute: typeof ServicesAppAdvertisingRoute
  ServicesAppAdvertisingServicesRoute: typeof ServicesAppAdvertisingServicesRoute
  ServicesBrandingCreativesRoute: typeof ServicesBrandingCreativesRoute
  ServicesBrandingCreativesAndBrandStrategyServicesRoute: typeof ServicesBrandingCreativesAndBrandStrategyServicesRoute
  ServicesBrandingCreativesAndCampaignDesignServicesRoute: typeof ServicesBrandingCreativesAndCampaignDesignServicesRoute
  ServicesBrandingCreativesAndLogoIdentityServicesRoute: typeof ServicesBrandingCreativesAndLogoIdentityServicesRoute
  ServicesBrandingCreativesAndMotionAiVideoServicesRoute: typeof ServicesBrandingCreativesAndMotionAiVideoServicesRoute
  ServicesBrandingCreativesAndOfficeBrandingServicesRoute: typeof ServicesBrandingCreativesAndOfficeBrandingServicesRoute
  ServicesBrandingCreativesAndPhotographyCopywritingServicesRoute: typeof ServicesBrandingCreativesAndPhotographyCopywritingServicesRoute
  ServicesBrandingCreativesAndVideoProductionServicesRoute: typeof ServicesBrandingCreativesAndVideoProductionServicesRoute
  ServicesCampaignDesignRoute: typeof ServicesCampaignDesignRoute
  ServicesCinemaRoute: typeof ServicesCinemaRoute
  ServicesCopywritingRoute: typeof ServicesCopywritingRoute
  ServicesCorporateOfficeBrandingRoute: typeof ServicesCorporateOfficeBrandingRoute
  ServicesCroRoute: typeof ServicesCroRoute
  ServicesCroServicesRoute: typeof ServicesCroServicesRoute
  ServicesDataIntelligenceRoute: typeof ServicesDataIntelligenceRoute
  ServicesDataIntelligenceServicesRoute: typeof ServicesDataIntelligenceServicesRoute
  ServicesDisplayNativeAdsRoute: typeof ServicesDisplayNativeAdsRoute
  ServicesDisplayNativeAdsServicesRoute: typeof ServicesDisplayNativeAdsServicesRoute
  ServicesEmailMarketingRoute: typeof ServicesEmailMarketingRoute
  ServicesEmailMarketingServicesRoute: typeof ServicesEmailMarketingServicesRoute
  ServicesLogoDesignRoute: typeof ServicesLogoDesignRoute
  ServicesMotionGraphicsRoute: typeof ServicesMotionGraphicsRoute
  ServicesOrmRoute: typeof ServicesOrmRoute
  ServicesOrmServicesRoute: typeof ServicesOrmServicesRoute
  ServicesOttAdvertisingRoute: typeof ServicesOttAdvertisingRoute
  ServicesOttAdvertisingServicesRoute: typeof ServicesOttAdvertisingServicesRoute
  ServicesOutdoorRoute: typeof ServicesOutdoorRoute
  ServicesOutdoorAdvertisingServicesRoute: typeof ServicesOutdoorAdvertisingServicesRoute
  ServicesPerformanceMarketingRoute: typeof ServicesPerformanceMarketingRoute
  ServicesPerformanceMarketingServicesRoute: typeof ServicesPerformanceMarketingServicesRoute
  ServicesPhotographyRoute: typeof ServicesPhotographyRoute
  ServicesPrintRoute: typeof ServicesPrintRoute
  ServicesProgrammaticAdvertisingRoute: typeof ServicesProgrammaticAdvertisingRoute
  ServicesProgrammaticAdvertisingServicesRoute: typeof ServicesProgrammaticAdvertisingServicesRoute
  ServicesRadioRoute: typeof ServicesRadioRoute
  ServicesResearchConsultingRoute: typeof ServicesResearchConsultingRoute
  ServicesResearchConsultingAndBrandAuditServicesRoute: typeof ServicesResearchConsultingAndBrandAuditServicesRoute
  ServicesResearchConsultingAndCampaignAuditServicesRoute: typeof ServicesResearchConsultingAndCampaignAuditServicesRoute
  ServicesResearchConsultingAndMediaAuditServicesRoute: typeof ServicesResearchConsultingAndMediaAuditServicesRoute
  ServicesResearchConsultingServicesRoute: typeof ServicesResearchConsultingServicesRoute
  ServicesSeoRoute: typeof ServicesSeoRoute
  ServicesSeoServicesRoute: typeof ServicesSeoServicesRoute
  ServicesSocialMediaMarketingRoute: typeof ServicesSocialMediaMarketingRoute
  ServicesSocialMediaMarketingServicesRoute: typeof ServicesSocialMediaMarketingServicesRoute
  ServicesTelevisionRoute: typeof ServicesTelevisionRoute
  ServicesVideoProductionRoute: typeof ServicesVideoProductionRoute
  ServicesVisualIdentityRoute: typeof ServicesVisualIdentityRoute
  ServicesWebDevelopmentRoute: typeof ServicesWebDevelopmentRoute
  ServicesWebDevelopmentServicesRoute: typeof ServicesWebDevelopmentServicesRoute
  DevServiceCinemaAdvertisingServicesRoute: typeof DevServiceCinemaAdvertisingServicesRoute
  DevServicePrintAdvertisementsServicesRoute: typeof DevServicePrintAdvertisementsServicesRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/work': {
      id: '/work'
      path: '/work'
      fullPath: '/work'
      preLoaderRoute: typeof WorkRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sitemap.xml': {
      id: '/sitemap.xml'
      path: '/sitemap.xml'
      fullPath: '/sitemap.xml'
      preLoaderRoute: typeof SitemapDotxmlRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services': {
      id: '/services'
      path: '/services'
      fullPath: '/services'
      preLoaderRoute: typeof ServicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/process': {
      id: '/process'
      path: '/process'
      fullPath: '/process'
      preLoaderRoute: typeof ProcessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/industries': {
      id: '/industries'
      path: '/industries'
      fullPath: '/industries'
      preLoaderRoute: typeof IndustriesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact-us': {
      id: '/contact-us'
      path: '/contact-us'
      fullPath: '/contact-us'
      preLoaderRoute: typeof ContactUsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blogs': {
      id: '/blogs'
      path: '/blogs'
      fullPath: '/blogs'
      preLoaderRoute: typeof BlogsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about-us': {
      id: '/about-us'
      path: '/about-us'
      fullPath: '/about-us'
      preLoaderRoute: typeof AboutUsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services_/web-development-services': {
      id: '/services_/web-development-services'
      path: '/services/web-development-services'
      fullPath: '/services/web-development-services'
      preLoaderRoute: typeof ServicesWebDevelopmentServicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services_/web-development': {
      id: '/services_/web-development'
      path: '/services/web-development'
      fullPath: '/services/web-development'
      preLoaderRoute: typeof ServicesWebDevelopmentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services_/visual-identity': {
      id: '/services_/visual-identity'
      path: '/services/visual-identity'
      fullPath: '/services/visual-identity'
      preLoaderRoute: typeof ServicesVisualIdentityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services_/video-production': {
      id: '/services_/video-production'
      path: '/services/video-production'
      fullPath: '/services/video-production'
      preLoaderRoute: typeof ServicesVideoProductionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services_/television': {
      id: '/services_/television'
      path: '/services/television'
      fullPath: '/services/television'
      preLoaderRoute: typeof ServicesTelevisionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services_/social-media-marketing-services': {
      id: '/services_/social-media-marketing-services'
      path: '/services/social-media-marketing-services'
      fullPath: '/services/social-media-marketing-services'
      preLoaderRoute: typeof ServicesSocialMediaMarketingServicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services_/social-media-marketing': {
      id: '/services_/social-media-marketing'
      path: '/services/social-media-marketing'
      fullPath: '/services/social-media-marketing'
      preLoaderRoute: typeof ServicesSocialMediaMarketingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services_/seo-services': {
      id: '/services_/seo-services'
      path: '/services/seo-services'
      fullPath: '/services/seo-services'
      preLoaderRoute: typeof ServicesSeoServicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services_/seo': {
      id: '/services_/seo'
      path: '/services/seo'
      fullPath: '/services/seo'
      preLoaderRoute: typeof ServicesSeoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services_/research-consulting-services': {
      id: '/services_/research-consulting-services'
      path: '/services/research-consulting-services'
      fullPath: '/services/research-consulting-services'
      preLoaderRoute: typeof ServicesResearchConsultingServicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services_/research-consulting-and-media-audit-services': {
      id: '/services_/research-consulting-and-media-audit-services'
      path: '/services/research-consulting-and-media-audit-services'
      fullPath: '/services/research-consulting-and-media-audit-services'
      preLoaderRoute: typeof ServicesResearchConsultingAndMediaAuditServicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services_/research-consulting-and-campaign-audit-services': {
      id: '/services_/research-consulting-and-campaign-audit-services'
      path: '/services/research-consulting-and-campaign-audit-services'
      fullPath: '/services/research-consulting-and-campaign-audit-services'
      preLoaderRoute: typeof ServicesResearchConsultingAndCampaignAuditServicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services_/research-consulting-and-brand-audit-services': {
      id: '/services_/research-consulting-and-brand-audit-services'
      path: '/services/research-consulting-and-brand-audit-services'
      fullPath: '/services/research-consulting-and-brand-audit-services'
      preLoaderRoute: typeof ServicesResearchConsultingAndBrandAuditServicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services_/research-consulting': {
      id: '/services_/research-consulting'
      path: '/services/research-consulting'
      fullPath: '/services/research-consulting'
      preLoaderRoute: typeof ServicesResearchConsultingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services_/radio': {
      id: '/services_/radio'
      path: '/services/radio'
      fullPath: '/services/radio'
      preLoaderRoute: typeof ServicesRadioRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services_/programmatic-advertising-services': {
      id: '/services_/programmatic-advertising-services'
      path: '/services/programmatic-advertising-services'
      fullPath: '/services/programmatic-advertising-services'
      preLoaderRoute: typeof ServicesProgrammaticAdvertisingServicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services_/programmatic-advertising': {
      id: '/services_/programmatic-advertising'
      path: '/services/programmatic-advertising'
      fullPath: '/services/programmatic-advertising'
      preLoaderRoute: typeof ServicesProgrammaticAdvertisingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services_/print': {
      id: '/services_/print'
      path: '/services/print'
      fullPath: '/services/print'
      preLoaderRoute: typeof ServicesPrintRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services_/photography': {
      id: '/services_/photography'
      path: '/services/photography'
      fullPath: '/services/photography'
      preLoaderRoute: typeof ServicesPhotographyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services_/performance-marketing-services': {
      id: '/services_/performance-marketing-services'
      path: '/services/performance-marketing-services'
      fullPath: '/services/performance-marketing-services'
      preLoaderRoute: typeof ServicesPerformanceMarketingServicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services_/performance-marketing': {
      id: '/services_/performance-marketing'
      path: '/services/performance-marketing'
      fullPath: '/services/performance-marketing'
      preLoaderRoute: typeof ServicesPerformanceMarketingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services_/outdoor-advertising-services': {
      id: '/services_/outdoor-advertising-services'
      path: '/services/outdoor-advertising-services'
      fullPath: '/services/outdoor-advertising-services'
      preLoaderRoute: typeof ServicesOutdoorAdvertisingServicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services_/outdoor': {
      id: '/services_/outdoor'
      path: '/services/outdoor'
      fullPath: '/services/outdoor'
      preLoaderRoute: typeof ServicesOutdoorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services_/ott-advertising-services': {
      id: '/services_/ott-advertising-services'
      path: '/services/ott-advertising-services'
      fullPath: '/services/ott-advertising-services'
      preLoaderRoute: typeof ServicesOttAdvertisingServicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services_/ott-advertising': {
      id: '/services_/ott-advertising'
      path: '/services/ott-advertising'
      fullPath: '/services/ott-advertising'
      preLoaderRoute: typeof ServicesOttAdvertisingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services_/orm-services': {
      id: '/services_/orm-services'
      path: '/services/orm-services'
      fullPath: '/services/orm-services'
      preLoaderRoute: typeof ServicesOrmServicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services_/orm': {
      id: '/services_/orm'
      path: '/services/orm'
      fullPath: '/services/orm'
      preLoaderRoute: typeof ServicesOrmRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services_/motion-graphics': {
      id: '/services_/motion-graphics'
      path: '/services/motion-graphics'
      fullPath: '/services/motion-graphics'
      preLoaderRoute: typeof ServicesMotionGraphicsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services_/logo-design': {
      id: '/services_/logo-design'
      path: '/services/logo-design'
      fullPath: '/services/logo-design'
      preLoaderRoute: typeof ServicesLogoDesignRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services_/email-marketing-services': {
      id: '/services_/email-marketing-services'
      path: '/services/email-marketing-services'
      fullPath: '/services/email-marketing-services'
      preLoaderRoute: typeof ServicesEmailMarketingServicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services_/email-marketing': {
      id: '/services_/email-marketing'
      path: '/services/email-marketing'
      fullPath: '/services/email-marketing'
      preLoaderRoute: typeof ServicesEmailMarketingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services_/display-native-ads-services': {
      id: '/services_/display-native-ads-services'
      path: '/services/display-native-ads-services'
      fullPath: '/services/display-native-ads-services'
      preLoaderRoute: typeof ServicesDisplayNativeAdsServicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services_/display-native-ads': {
      id: '/services_/display-native-ads'
      path: '/services/display-native-ads'
      fullPath: '/services/display-native-ads'
      preLoaderRoute: typeof ServicesDisplayNativeAdsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services_/data-intelligence-services': {
      id: '/services_/data-intelligence-services'
      path: '/services/data-intelligence-services'
      fullPath: '/services/data-intelligence-services'
      preLoaderRoute: typeof ServicesDataIntelligenceServicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services_/data-intelligence': {
      id: '/services_/data-intelligence'
      path: '/services/data-intelligence'
      fullPath: '/services/data-intelligence'
      preLoaderRoute: typeof ServicesDataIntelligenceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services_/cro-services': {
      id: '/services_/cro-services'
      path: '/services/cro-services'
      fullPath: '/services/cro-services'
      preLoaderRoute: typeof ServicesCroServicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services_/cro': {
      id: '/services_/cro'
      path: '/services/cro'
      fullPath: '/services/cro'
      preLoaderRoute: typeof ServicesCroRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services_/corporate-office-branding': {
      id: '/services_/corporate-office-branding'
      path: '/services/corporate-office-branding'
      fullPath: '/services/corporate-office-branding'
      preLoaderRoute: typeof ServicesCorporateOfficeBrandingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services_/copywriting': {
      id: '/services_/copywriting'
      path: '/services/copywriting'
      fullPath: '/services/copywriting'
      preLoaderRoute: typeof ServicesCopywritingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services_/cinema': {
      id: '/services_/cinema'
      path: '/services/cinema'
      fullPath: '/services/cinema'
      preLoaderRoute: typeof ServicesCinemaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services_/campaign-design': {
      id: '/services_/campaign-design'
      path: '/services/campaign-design'
      fullPath: '/services/campaign-design'
      preLoaderRoute: typeof ServicesCampaignDesignRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services_/branding-creatives-and-video-production-services': {
      id: '/services_/branding-creatives-and-video-production-services'
      path: '/services/branding-creatives-and-video-production-services'
      fullPath: '/services/branding-creatives-and-video-production-services'
      preLoaderRoute: typeof ServicesBrandingCreativesAndVideoProductionServicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services_/branding-creatives-and-photography-copywriting-services': {
      id: '/services_/branding-creatives-and-photography-copywriting-services'
      path: '/services/branding-creatives-and-photography-copywriting-services'
      fullPath: '/services/branding-creatives-and-photography-copywriting-services'
      preLoaderRoute: typeof ServicesBrandingCreativesAndPhotographyCopywritingServicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services_/branding-creatives-and-office-branding-services': {
      id: '/services_/branding-creatives-and-office-branding-services'
      path: '/services/branding-creatives-and-office-branding-services'
      fullPath: '/services/branding-creatives-and-office-branding-services'
      preLoaderRoute: typeof ServicesBrandingCreativesAndOfficeBrandingServicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services_/branding-creatives-and-motion-ai-video-services': {
      id: '/services_/branding-creatives-and-motion-ai-video-services'
      path: '/services/branding-creatives-and-motion-ai-video-services'
      fullPath: '/services/branding-creatives-and-motion-ai-video-services'
      preLoaderRoute: typeof ServicesBrandingCreativesAndMotionAiVideoServicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services_/branding-creatives-and-logo-identity-services': {
      id: '/services_/branding-creatives-and-logo-identity-services'
      path: '/services/branding-creatives-and-logo-identity-services'
      fullPath: '/services/branding-creatives-and-logo-identity-services'
      preLoaderRoute: typeof ServicesBrandingCreativesAndLogoIdentityServicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services_/branding-creatives-and-campaign-design-services': {
      id: '/services_/branding-creatives-and-campaign-design-services'
      path: '/services/branding-creatives-and-campaign-design-services'
      fullPath: '/services/branding-creatives-and-campaign-design-services'
      preLoaderRoute: typeof ServicesBrandingCreativesAndCampaignDesignServicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services_/branding-creatives-and-brand-strategy-services': {
      id: '/services_/branding-creatives-and-brand-strategy-services'
      path: '/services/branding-creatives-and-brand-strategy-services'
      fullPath: '/services/branding-creatives-and-brand-strategy-services'
      preLoaderRoute: typeof ServicesBrandingCreativesAndBrandStrategyServicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services_/branding-creatives': {
      id: '/services_/branding-creatives'
      path: '/services/branding-creatives'
      fullPath: '/services/branding-creatives'
      preLoaderRoute: typeof ServicesBrandingCreativesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services_/app-advertising-services': {
      id: '/services_/app-advertising-services'
      path: '/services/app-advertising-services'
      fullPath: '/services/app-advertising-services'
      preLoaderRoute: typeof ServicesAppAdvertisingServicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services_/app-advertising': {
      id: '/services_/app-advertising'
      path: '/services/app-advertising'
      fullPath: '/services/app-advertising'
      preLoaderRoute: typeof ServicesAppAdvertisingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services_/analytics-services': {
      id: '/services_/analytics-services'
      path: '/services/analytics-services'
      fullPath: '/services/analytics-services'
      preLoaderRoute: typeof ServicesAnalyticsServicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services_/analytics': {
      id: '/services_/analytics'
      path: '/services/analytics'
      fullPath: '/services/analytics'
      preLoaderRoute: typeof ServicesAnalyticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services_/ai-video-creation': {
      id: '/services_/ai-video-creation'
      path: '/services/ai-video-creation'
      fullPath: '/services/ai-video-creation'
      preLoaderRoute: typeof ServicesAiVideoCreationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services_/ai-marketing-services': {
      id: '/services_/ai-marketing-services'
      path: '/services/ai-marketing-services'
      fullPath: '/services/ai-marketing-services'
      preLoaderRoute: typeof ServicesAiMarketingServicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services_/ai-marketing': {
      id: '/services_/ai-marketing'
      path: '/services/ai-marketing'
      fullPath: '/services/ai-marketing'
      preLoaderRoute: typeof ServicesAiMarketingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/service_/television-advertising-services': {
      id: '/service_/television-advertising-services'
      path: '/service/television-advertising-services'
      fullPath: '/service/television-advertising-services'
      preLoaderRoute: typeof ServiceTelevisionAdvertisingServicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/service_/radio-advertising-services': {
      id: '/service_/radio-advertising-services'
      path: '/service/radio-advertising-services'
      fullPath: '/service/radio-advertising-services'
      preLoaderRoute: typeof ServiceRadioAdvertisingServicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/service_/print-advertisements-services': {
      id: '/service_/print-advertisements-services'
      path: '/service/print-advertisements-services'
      fullPath: '/service/print-advertisements-services'
      preLoaderRoute: typeof ServicePrintAdvertisementsServicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/service_/cinema-advertising-services': {
      id: '/service_/cinema-advertising-services'
      path: '/service/cinema-advertising-services'
      fullPath: '/service/cinema-advertising-services'
      preLoaderRoute: typeof ServiceCinemaAdvertisingServicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev_/service_/print-advertisements-services': {
      id: '/dev_/service_/print-advertisements-services'
      path: '/dev/service/print-advertisements-services'
      fullPath: '/dev/service/print-advertisements-services'
      preLoaderRoute: typeof DevServicePrintAdvertisementsServicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev_/service_/cinema-advertising-services': {
      id: '/dev_/service_/cinema-advertising-services'
      path: '/dev/service/cinema-advertising-services'
      fullPath: '/dev/service/cinema-advertising-services'
      preLoaderRoute: typeof DevServiceCinemaAdvertisingServicesRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  AboutUsRoute: AboutUsRoute,
  BlogsRoute: BlogsRoute,
  ContactUsRoute: ContactUsRoute,
  IndustriesRoute: IndustriesRoute,
  ProcessRoute: ProcessRoute,
  ServicesRoute: ServicesRoute,
  SitemapDotxmlRoute: SitemapDotxmlRoute,
  WorkRoute: WorkRoute,
  ServiceCinemaAdvertisingServicesRoute: ServiceCinemaAdvertisingServicesRoute,
  ServicePrintAdvertisementsServicesRoute:
    ServicePrintAdvertisementsServicesRoute,
  ServiceRadioAdvertisingServicesRoute: ServiceRadioAdvertisingServicesRoute,
  ServiceTelevisionAdvertisingServicesRoute:
    ServiceTelevisionAdvertisingServicesRoute,
  ServicesAiMarketingRoute: ServicesAiMarketingRoute,
  ServicesAiMarketingServicesRoute: ServicesAiMarketingServicesRoute,
  ServicesAiVideoCreationRoute: ServicesAiVideoCreationRoute,
  ServicesAnalyticsRoute: ServicesAnalyticsRoute,
  ServicesAnalyticsServicesRoute: ServicesAnalyticsServicesRoute,
  ServicesAppAdvertisingRoute: ServicesAppAdvertisingRoute,
  ServicesAppAdvertisingServicesRoute: ServicesAppAdvertisingServicesRoute,
  ServicesBrandingCreativesRoute: ServicesBrandingCreativesRoute,
  ServicesBrandingCreativesAndBrandStrategyServicesRoute:
    ServicesBrandingCreativesAndBrandStrategyServicesRoute,
  ServicesBrandingCreativesAndCampaignDesignServicesRoute:
    ServicesBrandingCreativesAndCampaignDesignServicesRoute,
  ServicesBrandingCreativesAndLogoIdentityServicesRoute:
    ServicesBrandingCreativesAndLogoIdentityServicesRoute,
  ServicesBrandingCreativesAndMotionAiVideoServicesRoute:
    ServicesBrandingCreativesAndMotionAiVideoServicesRoute,
  ServicesBrandingCreativesAndOfficeBrandingServicesRoute:
    ServicesBrandingCreativesAndOfficeBrandingServicesRoute,
  ServicesBrandingCreativesAndPhotographyCopywritingServicesRoute:
    ServicesBrandingCreativesAndPhotographyCopywritingServicesRoute,
  ServicesBrandingCreativesAndVideoProductionServicesRoute:
    ServicesBrandingCreativesAndVideoProductionServicesRoute,
  ServicesCampaignDesignRoute: ServicesCampaignDesignRoute,
  ServicesCinemaRoute: ServicesCinemaRoute,
  ServicesCopywritingRoute: ServicesCopywritingRoute,
  ServicesCorporateOfficeBrandingRoute: ServicesCorporateOfficeBrandingRoute,
  ServicesCroRoute: ServicesCroRoute,
  ServicesCroServicesRoute: ServicesCroServicesRoute,
  ServicesDataIntelligenceRoute: ServicesDataIntelligenceRoute,
  ServicesDataIntelligenceServicesRoute: ServicesDataIntelligenceServicesRoute,
  ServicesDisplayNativeAdsRoute: ServicesDisplayNativeAdsRoute,
  ServicesDisplayNativeAdsServicesRoute: ServicesDisplayNativeAdsServicesRoute,
  ServicesEmailMarketingRoute: ServicesEmailMarketingRoute,
  ServicesEmailMarketingServicesRoute: ServicesEmailMarketingServicesRoute,
  ServicesLogoDesignRoute: ServicesLogoDesignRoute,
  ServicesMotionGraphicsRoute: ServicesMotionGraphicsRoute,
  ServicesOrmRoute: ServicesOrmRoute,
  ServicesOrmServicesRoute: ServicesOrmServicesRoute,
  ServicesOttAdvertisingRoute: ServicesOttAdvertisingRoute,
  ServicesOttAdvertisingServicesRoute: ServicesOttAdvertisingServicesRoute,
  ServicesOutdoorRoute: ServicesOutdoorRoute,
  ServicesOutdoorAdvertisingServicesRoute:
    ServicesOutdoorAdvertisingServicesRoute,
  ServicesPerformanceMarketingRoute: ServicesPerformanceMarketingRoute,
  ServicesPerformanceMarketingServicesRoute:
    ServicesPerformanceMarketingServicesRoute,
  ServicesPhotographyRoute: ServicesPhotographyRoute,
  ServicesPrintRoute: ServicesPrintRoute,
  ServicesProgrammaticAdvertisingRoute: ServicesProgrammaticAdvertisingRoute,
  ServicesProgrammaticAdvertisingServicesRoute:
    ServicesProgrammaticAdvertisingServicesRoute,
  ServicesRadioRoute: ServicesRadioRoute,
  ServicesResearchConsultingRoute: ServicesResearchConsultingRoute,
  ServicesResearchConsultingAndBrandAuditServicesRoute:
    ServicesResearchConsultingAndBrandAuditServicesRoute,
  ServicesResearchConsultingAndCampaignAuditServicesRoute:
    ServicesResearchConsultingAndCampaignAuditServicesRoute,
  ServicesResearchConsultingAndMediaAuditServicesRoute:
    ServicesResearchConsultingAndMediaAuditServicesRoute,
  ServicesResearchConsultingServicesRoute:
    ServicesResearchConsultingServicesRoute,
  ServicesSeoRoute: ServicesSeoRoute,
  ServicesSeoServicesRoute: ServicesSeoServicesRoute,
  ServicesSocialMediaMarketingRoute: ServicesSocialMediaMarketingRoute,
  ServicesSocialMediaMarketingServicesRoute:
    ServicesSocialMediaMarketingServicesRoute,
  ServicesTelevisionRoute: ServicesTelevisionRoute,
  ServicesVideoProductionRoute: ServicesVideoProductionRoute,
  ServicesVisualIdentityRoute: ServicesVisualIdentityRoute,
  ServicesWebDevelopmentRoute: ServicesWebDevelopmentRoute,
  ServicesWebDevelopmentServicesRoute: ServicesWebDevelopmentServicesRoute,
  DevServiceCinemaAdvertisingServicesRoute:
    DevServiceCinemaAdvertisingServicesRoute,
  DevServicePrintAdvertisementsServicesRoute:
    DevServicePrintAdvertisementsServicesRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

import type { getRouter } from './router.tsx'
import type { startInstance } from './start.ts'
declare module '@tanstack/react-start' {
  interface Register {
    ssr: true
    router: Awaited<ReturnType<typeof getRouter>>
    config: Awaited<ReturnType<typeof startInstance.getOptions>>
  }
}
